<template lang="pug">
.opened-coupon-container
  .title-line
    .title-line-text 生活出行卡券
  free-coupon-tab.no-right-padding(
    :groupList="groupList"
    :more="!!(ladderPropGroupList && ladderPropGroupList.length)"
    @clickReceiveButton="(couponInfo)=>{ this.$emit('clickReceiveButton',couponInfo)}"
  )
  lockedCouponBLock(
    :ladderPropGroupList="ladderPropGroupList",
    :ladderDetailMap="ladderDetailMap"
    @clickReceiveButton="(couponInfo)=>{ this.$emit('clickReceiveButton',couponInfo)}"
    @notInAppJump="() =>{ $emit('notInAppJump')}"
    @open="()=>{this.openFlag = true}"
  )
  .ride-word(v-if="expansiveList")
    span 限时升级权益仅本月生效，次月起
    span.gc {{expansiveList[0].goodsPropDesc}}
    span.gc 权益恢复成
    span.gc {{expansiveList[0].propType!==4?expansiveList[0].amount:expansiveList[0].propTimes}}
    span.gc {{expansiveList[0].propType!==4?expansiveList[0].unit:'次'}}
</template>

<script>
import Lottie from '@/components/lottie';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import freeCouponTab from './free-coupon-tab.vue';
import lockedCouponTab from './locked-coupon-tab.vue';
import lockedCouponBLock from './locked-coupon-block.vue';

export default {
  components: {
    Lottie,
    freeCouponTab,
    lockedCouponTab,
    lockedCouponBLock,
  },
  props: {
    groupList: {
      type: Array,
      required: true,
    },
    ladderPropGroupList: {
      type: Array,
      required: true,
    },
    ladderDetailMap: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hasUseExposeFlag: false,
      hasReceiveExposeFlag: false,
      openFlag: false,
    };
  },
  computed: {
    expansiveList() {
      if (this.groupList && this.groupList.length > 0) {
        // eslint-disable-next-line array-callback-return
        const tempList = this.groupList[0].propList.filter((x) => {
        // eslint-disable-next-line no-unused-expressions
          x.vipExtendProperty;
        });
        if (tempList.length <= 0) {
          return false;
        }
        return tempList;
      }
      return false;
    },
  },
  watch: {
    groupList: {
      handler() {
        this.handleDataUBT();
      },
      immediate: true,
      deep: true,
    },
    ladderPropGroupList: {
      handler() {
        this.handleDataUBT();
      },
      immediate: true,
      deep: true,
    },
    openFlag: {
      handler(val) {
        if (val && this.ladderPropGroupList.length > 1
          && (!this.hasReceiveExposeFlag || !this.hasUseExposeFlag)) {
          const ladderList = [];
          this.ladderPropGroupList.slice(1).forEach((item) => (ladderList.push(...item.propList)));
          const hasUseBtnLadder = ladderList.some((item) => (item.btnName === '去使用' || item.btnName === '去APP使用'));
          const hasReceiveBtnLadder = ladderList.some((item) => (item.btnName === '领取'));
          this.exposeUBT(hasUseBtnLadder, hasReceiveBtnLadder);
        }
      },
    },
  },
  mounted() {
  },
  methods: {
    handleDataUBT() {
      if (!this.hasReceiveExposeFlag || !this.hasUseExposeFlag) {
        let freeList = [];
        if (this.groupList && this.groupList.length > 0) {
          freeList = this.groupList[0].propList || [];
        }
        let ladderList = [];
        if (this.ladderPropGroupList[0]) {
          ladderList = this.ladderPropGroupList[0].propList || [];
        }
        const tempList = [...freeList, ...ladderList];
        const hasUseBtnFree = tempList.some((item) => (item.btnName === '去使用' || item.btnName === '去APP使用'));
        const hasReceiveBtnFree = tempList.some((item) => (item.btnName === '领取'));
        this.exposeUBT(hasUseBtnFree, hasReceiveBtnFree);
      }
    },
    exposeUBT(hasUseBtnFree, hasReceiveBtnFree) {
      if (hasUseBtnFree && !this.hasUseExposeFlag) {
        this.hasUseExposeFlag = true;
        UBT.moduleExpose({
          pageId: 'platform_openedcard_page',
          categoryId: 'platform',
          moduleId: 'platform_coupon_use',
          contentId: 'platform_coupon_use',
          exposureTimes: 1,
          businessInfo: {
            BusinessLine: '0',
          },
        });
      }
      if (hasReceiveBtnFree && !this.hasReceiveExposeFlag) {
        this.hasReceiveExposeFlag = true;
        UBT.moduleExpose({
          pageId: 'platform_openedcard_page',
          categoryId: 'platform',
          moduleId: 'platform_coupon_get',
          contentId: 'platform_coupon_get',
          exposureTimes: 1,
          businessInfo: {
            BusinessLine: '0',
          },
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.opened-coupon-container {
  padding: 0.11rem 0.12rem 0 0.12rem;
  margin: 0.12rem 0.12rem 0.08rem 0.12rem;
  background-color: #fff;
  box-shadow: 0 0.02rem 0.04rem 0 rgba(241, 241, 241, 0.53);
  border-radius: 0.12rem;

  .no-right-padding {
    margin-right: -0.12rem;
  }

  .title-line {
    align-items: center;
    display: flex;
    height: 0.22rem;
    margin-bottom: 0.14rem;

    .title-line-number {
      width: 0.22rem;
      height: 0.22rem;
    }

    .title-line-text {
      margin-left: 0.04rem;
      height: 0.22rem;
      font-size: 0.16rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      color: #242729;
      line-height: 0.22rem;
    }
  }

  .ride-word {
    margin-top: 0.1rem;
    margin-left: 0.05rem;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    font-size: 0.11rem;
    font-weight: 400;
    line-height: 0.16rem;
    color: #879099;

    .gc {
      color: #7d3b2a;
    }
  }

  .more-coupons-bar {
    margin: 0 auto;
    width: 0.88rem;
    height: 0.29rem;
    background: #f7f7f7;
    border-radius: 0.16rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .more-text {
      width: 0.48rem;
      height: 0.17rem;
      font-size: 0.12rem;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #5a6066;
      line-height: 0.17rem;
    }

    .more-icon {
      width: 0.14rem;
      height: 0.14rem;
      margin-left: 0.02rem;
    }
  }
}

// .opened-coupon-container .locked-single-coupon-tab:last-of-type {
//   border: none;
// }</style>
